import React, {useEffect, useState} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import axios from "axios";
import {ISurvey} from "../../data/interfaces/ISurvey";
import {IQuestion} from "../../data/interfaces/IQuestion";
import {IQuestionGroup} from "../../data/interfaces/IQuestionGroup";
import {ISurveyUserData} from "../../data/interfaces/ISurveyUserData";
import {SurveyApi} from "../../data/api/SurveyApi";
import {SurveyService} from "../../data/services/SurveyService";
import {GroupComponent} from "./groupComponent";
import "./style.scss";


export function SurveyView() {

    const {id} = useParams();

    const [searchParams, setSearchParams] = useSearchParams();

    const surveyApi = SurveyApi();
    const surveyService = SurveyService();

    const [survey, setSurvey] = useState<ISurvey | undefined>(undefined);

    const [surveyCompleted, setSurveyCompleted] = useState<boolean>(false);

    const [data, setData] = useState<ISurveyUserData | undefined>(undefined)

    const mode = searchParams.get('mode') ?? "edit";


    const loadSurvey = async (id?: string) => {
        if(id != null) {
            try {
                if (mode !== "view") {
                    const response = await surveyApi.getUserData(searchParams.get('data') ?? "", axios.CancelToken.source().token);
                    if (response.data !== null) {
                        setData(response.data);
                        setSurveyCompleted(prev => (response.data.isResponsed === true && response.data.isUpdateAllowed !== true));
                    }
                }
                const response = await surveyApi.getSurvey(id, axios.CancelToken.source().token);
                if (response.data !== null) {
                    setSurvey(response.data);
                }

            } catch (ex: any) {
                setData(undefined);
                setSurvey(undefined);
            }
        }
        else {
            setData(undefined);
            setSurvey(undefined);
        }
    }

    const updateSurvey = (question: IQuestion) => {
        setSurvey(prev => {
            if(prev === undefined) {
                return prev;
            }

            const mapGroup: (g: IQuestionGroup) => IQuestionGroup = (g: IQuestionGroup) => {
                return {
                    ...g,
                    questions: g.questions.map(x => mapQuestion(x)),
                    groups: g.groups.map(x => mapGroup(x))
                } as IQuestionGroup;
            }

            const mapQuestion: (q: IQuestion) => IQuestion = (q: IQuestion) => {
                if(q.id === question.id) {
                    return question;
                }
                return q;
            }

            return {
                ...prev,
                questions: prev.groups.map(g => mapGroup(g))
            }
        })
    }

    const sendSurvey = async () => {
        if(survey !== undefined && mode !== 'view') {
            const request = {
                login: data?.email ?? "",
                surveyId: data?.surveyId ?? "",
                answers: getQuestion().map(q => {
                    return {
                        questionId: q.id,
                        value: q.selectedValue ?? 0,
                        customAnswer: q.customAnswer ?? ""
                    };
                }),
                data: searchParams.get('data') ?? ""
            };
            try {
                const response = await surveyApi.postSurvey(request, axios.CancelToken.source().token);
                if(response.data != null) {
                    setSurveyCompleted(prev => (prev || !response.data.hasErrors));
                }
            }
            catch (ex: any) { }
        }
    }


    const getQuestion = () => {
        const getGroupQuestions: (group: IQuestionGroup) => IQuestion[] = (group: IQuestionGroup) => {
            return [
                ...group.questions,
                ...group.groups.flatMap(g => getGroupQuestions(g))
            ] ?? [];
        }
        return survey?.groups.flatMap(g => {
            return [
                ...g.questions,
                ...g.groups.flatMap(g => getGroupQuestions(g))
            ];
        }) ?? []
    }

    const questions = getQuestion();


    useEffect(() => { loadSurvey(id); }, [id]);

    useEffect(() => { }, [mode]);


    return (
        <>

            {
                (survey !== undefined && surveyCompleted) && (
                    <div className={("survey-success-message")}>
                        Ваш отзыв обработан. Благодарим за уделенное время!
                    </div>
                )
            }

            {
                (survey !== undefined && !surveyCompleted) && (
                    <div className="survey-form-wrapper">
                        <div className="survey-form-container">

                            <div className="survey-form">

                                <div className="survey-form-title">{survey?.title}</div>

                                <div className="survey-form-description">
                                    {survey?.description}
                                </div>

                                {
                                    survey.groups.map((group, groupIndex) => {
                                        return (
                                            <GroupComponent
                                                key={groupIndex}
                                                group={group}
                                                onChange={(n) => updateSurvey(n)}
                                            />
                                        );
                                    })
                                }

                                {
                                    mode !== 'view' && (
                                        <button
                                            className="survey-form-btn"
                                            disabled={questions.some(x => x.isValid !== true)}
                                            onClick={() => sendSurvey()}
                                        >
                                            Отправить
                                        </button>
                                    )
                                }

                                {
                                    mode === 'view' && (
                                        <button
                                            className="survey-form-btn"
                                            style={{ cursor: 'default' }}
                                            disabled={questions.some(x => x.isValid !== true)}
                                        >
                                            Отправить
                                        </button>
                                    )
                                }

                            </div>

                        </div>

                    </div>
                )
            }
        </>
    );
}